export default __webpack_public_path__ + "static/media/financier-regular.af9ebef9.woff2";